import React from "react";
import { Button } from "./ui/button";
import { Card, CardContent } from "./ui/card";
import { MessageSquare, Phone, Clock } from "lucide-react";

const ContactSection = () => {
  const handleWhatsApp = () => {
    window.open("https://wa.me/6588921053?text=Hi, I'd like to book a valet service", "_blank");
  };

  const handleCall = () => {
    window.location.href = "tel:+6588921053";
  };

  const contactMethods = [
    {
      icon: MessageSquare,
      title: "WhatsApp",
      value: "+65 8892 1053",
      description: "Fastest way to book",
      action: handleWhatsApp,
      color: "from-yellow-50 to-amber-50",
      iconBg: "bg-yellow-100",
      iconColor: "text-yellow-700"
    },
    {
      icon: Phone,
      title: "Phone",
      value: "+65 8892 1053",
      description: "Call us anytime",
      action: handleCall,
      color: "from-amber-50 to-yellow-50",
      iconBg: "bg-amber-100",
      iconColor: "text-amber-700"
    },
    {
      icon: Clock,
      title: "Operating Hours",
      value: "9:00 PM - 4:00 AM",
      description: "7 days a week",
      color: "from-yellow-50 to-white",
      iconBg: "bg-yellow-100",
      iconColor: "text-yellow-700"
    }
  ];

  return (
    <section id="contact" className="py-24 px-6 bg-gradient-to-b from-yellow-50 to-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Get In Touch
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Ready to book? Contact us via WhatsApp or phone for quick and easy booking
          </p>
        </div>

        {/* Contact Methods Grid */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {contactMethods.map((method, index) => {
            const Icon = method.icon;
            return (
              <Card
                key={index}
                className={`border-2 border-yellow-200 shadow-lg hover:shadow-xl transition-all cursor-pointer card-hover bg-gradient-to-br ${method.color}`}
                onClick={method.action}
              >
                <CardContent className="p-8 text-center">
                  <div className={`w-16 h-16 ${method.iconBg} rounded-full flex items-center justify-center mx-auto mb-4`}>
                    <Icon className={`w-8 h-8 ${method.iconColor}`} />
                  </div>
                  <h3 className="text-xl font-bold text-slate-900 mb-2">
                    {method.title}
                  </h3>
                  <p className="text-2xl font-semibold text-slate-800 mb-1">
                    {method.value}
                  </p>
                  <p className="text-slate-600">{method.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Main CTA */}
        <div className="bg-gradient-to-r from-yellow-400 to-amber-400 rounded-2xl shadow-2xl p-12 text-center">
          <MessageSquare className="w-16 h-16 text-black mx-auto mb-6" />
          <h3 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
            Schedule Your Valet Now
          </h3>
          <p className="text-xl text-slate-800 mb-8 max-w-2xl mx-auto">
            Click below to start a WhatsApp chat and book your safe ride home in seconds
          </p>
          <Button
            onClick={handleWhatsApp}
            size="lg"
            className="bg-black text-white hover:bg-slate-800 text-lg px-12 py-6 h-auto font-semibold shadow-lg"
          >
            <MessageSquare className="w-5 h-5 mr-2" />
            Start WhatsApp Chat
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
